"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notificacao = void 0;
var react_1 = __importStar(require("react"));
var Icone_1 = require("../Icone/Icone");
var Cores_1 = require("../Cores/Cores");
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var estilosNotificacao = require("./Notificacao.module.scss");
var Notificacao = function (props) {
    var _a, _b, _c;
    var tipo = props.tipo, estado = props.estado, _d = props.posicao, posicao = _d === void 0 ? "superiorDireita" : _d, notificacaoChildren = props.notificacaoChildren, children = props.children;
    var tipos = estilosNotificacao[tipo];
    var estados = estilosNotificacao[estado];
    var posicoes = estilosNotificacao[posicao];
    var conteudo = null;
    var isConteudoValido = function () {
        switch (tipo) {
            case "ponto":
                return true;
            case "numero":
                return typeof props.conteudoNotificacao === "number";
            case "icone":
                return typeof props.conteudoNotificacao === "string";
            case "texto":
                return typeof props.conteudoNotificacao === "string" && props.conteudoNotificacao.trim() !== "";
            case "textoComIcone":
                return (typeof props.conteudoNotificacao === "object" &&
                    props.conteudoNotificacao !== null &&
                    typeof props.conteudoNotificacao.texto === "string" &&
                    props.conteudoNotificacao.texto.trim() !== "" &&
                    typeof props.conteudoNotificacao.icone === "string");
            default:
                return false;
        }
    };
    if (isConteudoValido()) {
        switch (tipo) {
            case "ponto":
                conteudo = react_1.default.createElement("div", { className: estilosNotificacao.ponto });
                break;
            case "numero": {
                var valor = (_a = props.conteudoNotificacao) !== null && _a !== void 0 ? _a : 0;
                if (valor < 0)
                    valor = 0;
                var valorStr = valor > 99 ? "99+" : valor;
                conteudo = (react_1.default.createElement(Corpo_1.Corpo, { tipo: "overline", cor: Cores_1.Cores.CoresIdentidadeMU.brancoMu, negrito: 400 }, valorStr));
                break;
            }
            case "icone":
                conteudo = (react_1.default.createElement(Icone_1.Icone, { altura: "12px", largura: "12px", cor: Cores_1.Cores.CoresIdentidadeMU.brancoMu, nome: props.conteudoNotificacao }));
                break;
            case "texto":
                conteudo = (react_1.default.createElement(Corpo_1.Corpo, { tipo: "overline", cor: Cores_1.Cores.CoresIdentidadeMU.brancoMu, negrito: 400 }, props.conteudoNotificacao));
                break;
            case "textoComIcone":
                conteudo = (react_1.default.createElement("div", { style: { display: "flex", gap: "4px" } },
                    react_1.default.createElement(Icone_1.Icone, { altura: "12px", largura: "12px", cor: Cores_1.Cores.CoresIdentidadeMU.brancoMu, nome: (_b = props.conteudoNotificacao) === null || _b === void 0 ? void 0 : _b.icone }),
                    react_1.default.createElement(Corpo_1.Corpo, { tipo: "overline", cor: Cores_1.Cores.CoresIdentidadeMU.brancoMu, negrito: 400 }, (_c = props.conteudoNotificacao) === null || _c === void 0 ? void 0 : _c.texto)));
                break;
        }
    }
    (0, react_1.useEffect)(function () {
        console.log(tipo, estado, posicao);
    }, [tipo, estado, posicao]);
    return (react_1.default.createElement("div", { className: estilosNotificacao.children },
        react_1.default.createElement("div", { className: "".concat(estilosNotificacao.conteudo, " ").concat(tipos, " ").concat(estados, " ").concat(posicoes) }, conteudo), children !== null && children !== void 0 ? children : notificacaoChildren));
};
exports.Notificacao = Notificacao;
